// extracted by mini-css-extract-plugin
export default {"query_page":"SearchPage_query_page__vpRNQ","full_skeleton_left":"SearchPage_full_skeleton_left__-CxZd","full_skeleton_right":"SearchPage_full_skeleton_right__ytjZW"};